import { useContext } from "react";

import { CheckoutPageContext } from "../contexts";

export function useCheckoutPage() {
  return useContext(CheckoutPageContext);
}
